/* =========================================================
   RAVEN STORE — theme behaviour
   ========================================================= */
(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function url(path) { return (routes.replace(/\/$/, '')) + path; }

  var state = { cartOpen: false };

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function drawer() { return $('#rv-cart-drawer'); }

  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count-target]').forEach(function (el) {
      el.textContent = n;
    });
  }

  function applyOpenState() {
    var d = drawer();
    if (!d) return;
    d.classList.toggle('is-open', state.cartOpen);
    document.body.style.overflow = state.cartOpen ? 'hidden' : '';
    var fromCount = d.getAttribute('data-cart-count');
    if (fromCount != null) setCartCount(fromCount);
  }

  function openCart() { state.cartOpen = true; applyOpenState(); }
  function closeCart() { state.cartOpen = false; applyOpenState(); }

  /* ---------- render cart drawer from Section Rendering API ---------- */
  function swapDrawer(html) {
    var wrapper = $('#shopify-section-cart-drawer');
    if (wrapper && typeof html === 'string') {
      wrapper.innerHTML = html;
      applyOpenState();
    }
  }

  function fetchDrawer() {
    return fetch(url('/?sections=cart-drawer'))
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data['cart-drawer']) swapDrawer(data['cart-drawer']); });
  }

  /* ---------- cart mutations ---------- */
  function addToCart(variantId, quantity, btn) {
    if (!variantId) return;
    if (btn) { btn.dataset.label = btn.textContent; btn.textContent = '···'; btn.disabled = true; }
    fetch(url('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }], sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { // error (e.g. sold out)
          flash(data.description || 'Nuk u shtua dot në shportë');
        } else {
          if (data.sections && data.sections['cart-drawer']) swapDrawer(data.sections['cart-drawer']);
          openCart();
        }
      })
      .catch(function () { flash('Diçka shkoi keq'); })
      .finally(function () {
        if (btn) { btn.textContent = btn.dataset.label || 'Shto në Shportë'; btn.disabled = false; }
      });
  }

  function changeLine(line, quantity) {
    fetch(url('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) swapDrawer(data.sections['cart-drawer']);
      });
  }

  function flash(msg) {
    var el = document.createElement('div');
    el.textContent = msg;
    el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:var(--rv-crimson);color:#fff;padding:.8rem 1.2rem;border-radius:999px;z-index:200;font-weight:700;letter-spacing:.04em;text-transform:uppercase;font-size:.8rem;box-shadow:0 12px 30px -8px rgba(225,29,42,.7)';
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 2600);
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

    var add = t.closest('[data-add-variant]');
    if (add) {
      e.preventDefault();
      addToCart(add.getAttribute('data-add-variant'), 1, add);
      return;
    }

    var inc = t.closest('[data-line-inc]');
    if (inc) { changeLine(inc.getAttribute('data-line-inc'), inc.getAttribute('data-qty')); return; }
    var dec = t.closest('[data-line-dec]');
    if (dec) { changeLine(dec.getAttribute('data-line-dec'), dec.getAttribute('data-qty')); return; }
    var rem = t.closest('[data-line-remove]');
    if (rem) { changeLine(rem.getAttribute('data-line-remove'), 0); return; }

    var burger = t.closest('[data-menu-toggle]');
    if (burger) {
      var mnav = $('#rv-mnav');
      if (mnav) mnav.classList.toggle('is-open');
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.cartOpen) closeCart();
  });

  /* ---------- PDP: variant picker ---------- */
  function initProductForm(form) {
    var dataEl = $('[data-variant-json]', form);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var priceEl = $('[data-pdp-price]', form);
    var compareEl = $('[data-pdp-compare]', form);
    var addBtn = $('[data-pdp-add]', form);
    var idField = $('[data-variant-id-field]', form);
    var moneyFormat = dataEl.getAttribute('data-money-format') || '${{amount}}';

    function fmtMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, amount)
                        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
    }

    function currentOptions() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked') || group.querySelector('select');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      if (idField) idField.value = match.id;
      if (addBtn) addBtn.setAttribute('data-add-variant', match.id);
      if (priceEl) priceEl.textContent = fmtMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = fmtMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (addBtn) {
        if (match.available) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-label-add') || 'Shto në Shportë'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Sosur'; }
      }
    }

    form.addEventListener('change', update);
    update();
  }

  /* ---------- newsletter (footer) graceful submit ---------- */
  // Shopify customer form posts natively; nothing to intercept.

  /* ---------- init ---------- */
  function setHeaderOffset() {
    var h = $('.rv-header');
    if (h) document.documentElement.style.setProperty('--rv-mnav-top', h.offsetHeight + 'px');
  }

  function init() {
    applyOpenState();
    setHeaderOffset();
    window.addEventListener('resize', setHeaderOffset);
    document.querySelectorAll('[data-product-form]').forEach(initProductForm);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
